<template>
  <v-card>
    <v-card-title>
      <span class="headline">Selecione seu novo plano</span>
    </v-card-title>
    <v-card-text>
      <p>O plano será alterado na próxima cobrança</p>
      <div v-if="planosRetornados && planosRetornados.length > 0">
        <v-divider class="my-4"></v-divider>
        <h3 class="mb-4">Planos Disponíveis:</h3>
        <template v-for="(plano, index) in planosRetornados" :key="plano.id || index">
          <v-card class="mb-4" outlined>
            <v-card-text>
              <p><strong>Nome:</strong> {{ plano.title }}</p>
              <p><strong>Descrição:</strong> {{ plano.description }}</p>
              <div v-if="plano.features && plano.features.length > 0">
                <p class="mt-3 mb-2"><strong>Features Inclusas:</strong></p>
                <v-row no-gutters>
                  <v-col
                    cols="12"
                    sm="6"
                    v-for="(feature, featIndex) in plano.features"
                    :key="featIndex"
                    class="d-flex align-center mb-1 pr-3"
                  >
                    <v-icon small color="green darken-1" class="mr-2">mdi-check-circle</v-icon>
                    <span>{{ feature }}</span>
                  </v-col>
                </v-row>
              </div>
              <p v-else class="mt-3">Nenhuma feature listada para este plano.</p>
              <p class="mt-3"><strong>Custo:</strong> {{ plano.value }}</p>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-checkbox
                :label="`Selecionar`"
                :value="plano.id"
                v-model="planoSelecionado"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-card-actions>
          </v-card>
          <v-divider v-if="index < planosRetornados.length - 1" class="my-4"></v-divider>
        </template>
      </div>
      <div v-else-if="planosRetornados === null">
        <p>Carregando planos...</p>
      </div>
      <div v-else>
        <p>Nenhum plano disponível no momento.</p>
      </div>
    </v-card-text>

    <v-dialog v-model="dialogCartaoAberto" max-width="600px" persistent>
      <dialogCard
        @cartao-selecionado="handleCartaoSelecionado"
        @voltar="dialogCartaoAberto = false"
      />
    </v-dialog>
    <v-card-actions>
      <v-btn elevation="0" color="red darken-1" @click="dialogCartaoAberto = true">
        {{ cartaoSelecionado ? 'Cartão Selecionado' : 'Selecionar Cartão' }}
        <v-icon v-if="cartaoSelecionado" right color="green">mdi-check</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="fechar()">Cancelar</v-btn>
      <v-btn 
        color="green darken-1" 
        text 
        @click="salvar()" 
        :disabled="!planoSelecionado || !cartaoSelecionado"
      >
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { getAllPlanos } from "../libs/getPlano";
import dialogCard from "../components/dialogCard.vue";

export default {
  components: {
    dialogCard
  },
  data() {
    return {
      planoRetornado: null,
      planosRetornados: null,
      planoSelecionado: null,
      dialogCartaoAberto: false,
      cartaoSelecionado: null
    };
  },
  methods: {
    fechar() {
      this.$emit('fechar-dialog');
    },
    salvar() {
      const planoCompleto = this.planosRetornados.find(
        plano => plano.id === this.planoSelecionado
      );
      if (!planoCompleto) {
        console.error("Erro: Plano selecionado não encontrado.");
        return;
      }
      const precoPlano = planoCompleto.value.replace("R$ ","");
      const dadosSelecao = {
        planoId: this.planoSelecionado,
        preco: precoPlano,
        cartao: this.cartaoSelecionado
      };
      this.$emit('plano-selecionado', dadosSelecao);
      this.$emit('fechar-dialog');
    },
    handleCartaoSelecionado(cartao) {
      this.cartaoSelecionado = cartao;
      this.dialogCartaoAberto = false;
    },
    async carregarPlanos() {
      try {
        const result = await getAllPlanos();
        if (Array.isArray(result)) {
          this.planosRetornados = result;
        } else if (result) {
          this.planosRetornados = [result];
        } else {
          this.planosRetornados = [];
        }
      } catch (error) {
        console.error('Erro ao carregar planos:', error);
        this.planosRetornados = [];
      }
    }
  },
  created() {
    this.carregarPlanos();
  }
};
</script>

<style scoped>
.v-card-text {
  max-height: 400px;
  overflow-y: auto;
}
</style>